import { combineReducers } from 'redux';
import { parsePlayer, getPlayersById } from '../players/utils';

const getPlayersBySlotId = (resp = []) =>
  (Array.isArray(resp) ? resp : []).reduce((acc, curr) => {
    if (!curr?.id) {
      return acc;
    }
    return {
      ...acc,
      [curr.id]: Array.isArray(curr.players) ? curr.players : [],
    };
  }, {});

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_START':
      return true;
    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_PLAYER_DATA_FAILURE':
    case 'FETCH_PLAYER_DATA_NO_CONTEST':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return false;
    default:
      return state;
  }
};

const byPlayerId = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
      return getPlayersById(action.resp?.sets);
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return (action.resp?.picks || []).reduce((acc, entry) => {
        const player = entry?.player;
        if (!player?.id) {
          return acc;
        }
        return {
          ...acc,
          [player.id]: {
            ...player,
            fullName: `${parsePlayer(player).firstName} ${parsePlayer(player).lastName}`,
          },
        };
      }, {});
    default:
      return state;
  }
};

const bySlotId = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
      return getPlayersBySlotId(action.resp?.sets);
    default:
      return state;
  }
};

const bySlotPlayerCount = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS': {
      const playersBySlot = getPlayersBySlotId(action.resp?.sets);

      return Object.keys(playersBySlot).reduce((acc, id) => {
        const players = playersBySlot[id] || [];

        return {
          ...acc,
          [id]: players.length,
        };
      }, {});
    }
    default:
      return state;
  }
};

const playersPicked = (state = false, action) => {
  switch (action.type) {
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetching,
  byPlayerId,
  bySlotId,
  bySlotPlayerCount,
  playersPicked,
});
